import React from 'react';
interface CTAButtonProps {
  label: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  label,
  href = 'https://the-esl-survival-vault.impultienda.ar/checkout',
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`cta-button flex min-h-[54px] w-full items-center justify-center rounded-[10px] bg-vault-gold px-6 py-4 text-center text-base font-extrabold text-midnight-navy shadow-lg shadow-vault-gold/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-vault-gold sm:text-[17px] ${className}`} data-id="element-50" data-mp="2l0984jc57s14">
      {label}
    </a>;
}